import { Component, OnInit } from "@angular/core";
import { DataService } from "../service/buildings.service";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
  homeMenuTitles = [
    "'filter.buyTitle' | translate",
    "'filter.rentTitle' | translate",
    "'filter.sellTitle' | translate",
    "'filter.estimateTitle' | translate",
  ];
  homeMenuButtons = [  'pageHeader.Buy | translate', 'pageHeader.Rent | translate', 'pageHeader.Sell | translate', "Baxolash"];
  homeMenuId = 0;
  keyword:string;
  
  constructor(private data : DataService, private router: Router) {}

  ngOnInit() {

    this.data.currentMessage.subscribe(keyword => this.keyword = keyword);

    console.log("home keyword:"+this.keyword);
    
    console.log("home keyword:"+this.keyword);


  }
  newMessage(form: NgForm) {
    console.log("keyword:"+form.value.keyword);
    
    this.data.changeMessage(form.value.keyword);
        
    this.router.navigateByUrl('/buy');
  }
}
